import React from "react";
import "./Footer.scss";
import { config } from "../../API/environment";
import { PRIVACY_POLICY_URL, TERMS_OF_USE_URL } from "../../Constants/constants";

const Footer = () => (
  <div className="Footer d-flex align-items-center">
    <div>
      Clinithink Customer Portal - Version {config.BUILDVERSION} - Copyright ©{" "}
      {new Date().getFullYear()} Clinithink Ltd. All rights reserved.
    </div>
    <div className="footer-links">
      <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
        <span className="footer-privacy-policy">Clinithink | Privacy policy</span>
      </a>
      <a href={TERMS_OF_USE_URL} target="_blank" rel="noopener noreferrer">
        <span className="footer-privacy-policy">| Standard terms</span>
      </a>
    </div>
  </div>
);
export default Footer;
